import OnMountIsLoadedMixin from '@/mixins/on-mount-is-loaded';
import { ILocationUserMessageContent } from '@/models/bot-models';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class UserLocationMessage extends OnMountIsLoadedMixin {
    @Prop({ default: () => ({}) }) public content!: ILocationUserMessageContent;
}
